export type Document = {
  file_id: string
  file_uri: string
  dataset_id: string
  filename: string | null
  relative_path: string | null
  metadata: {
    filetype: string | null
    filename: string | null
    // Number of page in PDF, number of sheet in excel
    page_numbers: number | null
    page_names: number | null
    // for emails
    sent_from: Array<string> | null
    sent_to: Array<string> | null
    attached_to: null
    paragraph_uuids: Array<string> | null
  }
}

export type RetrievedImage = {
  position: number
  title: string
  url: string
}

export type SystemMessage = {
  type: 'system'
  answer: string
  created_at: string
  order: number
  error?: string
  documents: Array<Document>
  images?: Array<RetrievedImage>
  language?: string
  extension_filter?: Array<string>
  strategy?: string
}

export type UserMessage = {
  type: 'user'
  created_at: string
  query: string
  files?: Array<{
    type: string
    file_id: string
  }>
  documents?: Array<Document>
}

export type MessageType = SystemMessage | UserMessage
export function isSystemMessage(message?: MessageType): message is SystemMessage {
  return message?.type === 'system'
}

export type ConversationType = {
  chat_id: string
  created_at: string
  first_user_query: string
  index_id: number
  messages?: Array<MessageType>
}

export type ResponseMessage = {
  event: 'workflow_started' | 'message' | 'node_finished' | 'workflow_finished' | 'error'
  message_id: string
  answer: string
  query: string
  data: any
  documents?: Array<Document>
  conversation_id: string
  task_id: string
  error?: string
}
